import { AlignmentType, BorderStyle, HeadingLevel, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, VerticalAlign, WidthType } from "docx";

export const ObjectivesScopeHeading = new Paragraph({
    spacing: { before: 150, after: 300 },
    children: [new TextRun({
        text: "3.  Objectives and Scope",
        bold: true
    })],
    heading: HeadingLevel.HEADING_2,
})


export function ObjectiveandScopeText(applicationName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { before: 450, after: 300 },
        // spacing: { line: 276, after: 10 * 72 * 0.05 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION security testing team performed Source Code Security Audit on ${applicationName}. The overall objective and goal of this engagement was to:`,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export const objectiveBulletOne = new Paragraph({
    indent: { left: 400 },
    bullet: { level: 0 },
    alignment: AlignmentType.JUSTIFIED,
    spacing: { line: 350, before: 250 },
    children: [
        new TextRun({
            text: "Identify Vulnerabilities in application source code by manual and automated methodologies. ",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const objectiveBulletTwo = new Paragraph({
    indent: { left: 400 },
    bullet: { level: 0 },
    alignment: AlignmentType.JUSTIFIED,
    spacing: { line: 350 },
    children: [
        new TextRun({
            text: "Identify the extent to which the application under the purview of this exercise is vulnerable to threats.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const objectiveBulletThree = new Paragraph({
    indent: { left: 400 },
    bullet: { level: 0 },
    spacing: { line: 350, },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Recommend steps that need to be in place to mitigate the risks that arise due to the existence of these vulnerabilities.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const objectiveBulletFour = new Paragraph({
    indent: { left: 400 },
    bullet: { level: 0 },
    spacing: { line: 350 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Compliance to industry standards and security best practices.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})


export const scopeHeading = new Paragraph({
    spacing: { before: 450, after: 300 },
    children: [new TextRun({
        text: "Scope",
        bold: true,
        color: "c00000",
        size: 26,
        font: "Cambria"
    })],
})

export function scope1(certInCustomerName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: "ISECURION performed Source Code Security Audit on the below mentioned provided by" + certInCustomerName + ".",
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export function scopeTable(certInApplicationName) {
    return new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 450 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        width: { size: 9, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Sl. No",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 22, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Application Name",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 190, after: 190 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "1",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 190, after: 190 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: certInApplicationName,
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    }),

                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                ]
            }),
        ]
    })
}



